import SearchWidget from './SearchWidget';

const widgets = {
  contact: SearchWidget,
  search: SearchWidget,
  subscribe: SearchWidget,
};

export default widgets;
